import React from "react";
import { useActor } from "@xstate/react";
import SingleSelect from "../SingleSelect";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { RevenueValue } from "../../constants/signup-value.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";
const RevenueStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const revenueValue = formData[SignUpFormField.Revenue];

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.Revenue]: value },
    });
  };

  const field = {
    id: SignUpFormField.Revenue,
    required: true,
    options: [
      {
        id: "input-revenue-35k+",
        label: "$35k+",
        value: RevenueValue.ThirtyFiveKPlus,
      },
      {
        id: "input-revenue-25-35k",
        label: "$25k–$35k",
        value: RevenueValue.TwentyFiveToThirtyFiveK,
      },
      {
        id: "input-revenue-8-25k",
        label: "$8k–$25k",
        value: RevenueValue.EightToTwentyFiveK,
      },
      {
        id: "input-revenue-0-8k",
        label: "$0–$8k",
        value: RevenueValue.LessThan8K,
      },
      {
        id: "input-revenue-no-value",
        label: "Prefer not to share",
        value: RevenueValue.PreferNotToShare,
        style: "link",
      },
    ],
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="What is your typical monthly revenue?" />
      </div>
      <div className="tw-space-y-4">
        <SingleSelect
          options={field.options}
          onChange={handleChange}
          value={revenueValue}
          progressOnSelect={() => send({ type: "NEXT" })}
        />
      </div>
    </>
  );
};

export default RevenueStep;
